import { DecisionCondition, DecisionFieldType } from './WorkflowBuilder.types';

const FIELD_FRIENDLY: Record<DecisionFieldType, string> = {
    call_disposition: 'call disposition',
    call_status: 'call status',
    party_stage: 'party stage',
    sms_status: 'SMS status',
};

export function decisionFieldFriendlyName(field: DecisionFieldType): string {
    return FIELD_FRIENDLY[field];
}

/** One line per decisionField with a count of condition rows (not values). */
export function buildDecisionNodeSubLabel(conditions: DecisionCondition[]): string {
    if (!conditions?.length) return 'No conditions';

    const order: DecisionFieldType[] = ['call_disposition', 'call_status', 'party_stage', 'sms_status'];
    const counts = new Map<DecisionFieldType, number>();
    conditions.forEach((c) => {
        counts.set(c.decisionField, (counts.get(c.decisionField) ?? 0) + 1);
    });

    const parts: string[] = [];
    order.forEach((field) => {
        const n = counts.get(field);
        if (n && n > 0) {
            const name =
                field === 'call_disposition'
                    ? 'Call disposition'
                    : field === 'call_status'
                      ? 'Call status'
                      : field === 'party_stage'
                        ? 'Party stage'
                        : 'SMS status';
            parts.push(`${name} – ${n} condition${n === 1 ? '' : 's'}`);
        }
    });
    return parts.join('\n');
}

const NEXT_TYPE_LABEL: Record<'CALL' | 'SMS' | 'DELAY' | 'END', string> = {
    CALL: 'Call',
    SMS: 'SMS',
    DELAY: 'Delay',
    END: 'End',
};

export function buildBranchNodeLabel(
    nextNodeType: 'CALL' | 'SMS' | 'DELAY' | 'END',
    decisionField: DecisionFieldType,
    values: string[],
    isDefault?: boolean
): string {
    const typeWord = NEXT_TYPE_LABEL[nextNodeType];
    if (isDefault) {
        return `${typeWord} node - default`;
    }
    const field = decisionFieldFriendlyName(decisionField);
    const vals = values.length ? values.join(', ') : '';
    return `${typeWord} node - ${field} ${vals}`.trim();
}
